export const PuzzlesData = [
  {
    id: 'mate_in_1_01',
    fen: '3ak4/4a4/9/9/9/9/9/4R4/9/4K4 w - - 0 1',
    solution: ['e2e8'], // Xe đâm xuống đáy chiếu bí
    theme: 'Sát cục 1 nước',
    title: 'Xe đâm đáy',
    difficulty: 'easy'
  },
  {
    id: 'endgame_01',
    fen: '4k4/4a4/9/9/9/9/9/9/4N4/4K4 w - - 0 1',
    solution: ['e1c2', 'e9e8', 'c2d4', 'e8e9', 'd4e6'],
    theme: 'Cờ tàn cơ bản',
    title: 'Đơn Mã Thắng Đơn Sĩ',
    difficulty: 'medium'
  }
];
